import Routing from "./Routing/index.jsx";

function App() {
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
